import { useMediaQuery } from './useMediaQuery';

/**
 * Canonical mobile breakpoint for the whole app.
 *
 * Convention (see plan "Mobile / Responsive Support"):
 * - Pure layout changes: CSS `@media (max-width: 768px)` in the component's
 *   own .css file (use this same 768px value).
 * - Behavioral changes (drawer, tab gating, tap semantics, not mounting
 *   desktop-only DOM): `useIsMobile()` in JSX.
 *
 * Two clauses:
 * - width ≤768px: portrait phones AND devtools emulation (same code path).
 * - coarse pointer + height ≤500px: a PHONE rotated to landscape (812×375
 *   etc.) — width alone would flip it to the desktop UI, which is neither
 *   designed nor gated for phones. Desktop monitors never match (fine
 *   pointer / tall viewport).
 */
export const MOBILE_QUERY =
  '(max-width: 768px), ((pointer: coarse) and (max-height: 500px))';

export const useIsMobile = () => useMediaQuery(MOBILE_QUERY);

/** True while the device is in portrait orientation (viewer rotate-overlay). */
export const useIsPortrait = () => useMediaQuery('(orientation: portrait)');

/** Touch-first pointer — used ONLY by the viewer gesture adapter, never for layout. */
export const useIsCoarsePointer = () => useMediaQuery('(pointer: coarse)');

export default useIsMobile;
